import { ElementRef, inject } from '@angular/core';
import { FormModes } from './constants.lib';
import { ToastrService } from 'ngx-toastr';
import { CasiStoryStatus } from '../models/models.lib';
// import { RuleEval } from "@casi-ts/utils";

export const setTitle = (formMode: FormModes, title: string): string => {
  return `${formMode === FormModes.VIEW ? 'VIEW' : formMode === FormModes.NEW ? 'ADD' : formMode === FormModes.EDIT ? 'EDIT' : ''} ${title}`;
};

export const findNearestNumber = (arr: number[], target: number): number => {
  // console.log('findNearestNumber: ', target, arr);
  let nearest = arr[0];
  let smallestDifference = Math.abs(target - nearest);
  arr.forEach(a => {
    const difference = Math.abs(target - a);
    if (difference < smallestDifference) {
      nearest = a;
      smallestDifference = difference;
    }
  })
  return nearest;
};

// export function isNotNull(val = null) {
//   return !!val || !(val === null);
// };


export function isNotNull(val: any = null) {
  return !!val || !(val === null);
};

export function casiNotify(msg: string = 'Not set', error: boolean = false): void {
  let toastr = inject(ToastrService);
  if (error) {
    toastr.error(msg, 'Error');
  } else {
    toastr.success(msg, 'Sucess');
  }
};

export const sureThing = (promise: Promise<any>): Promise<any> =>
  promise
    .then((data) => ({
      ok: true,
      data
    }))
    .catch((error) => Promise.resolve({
      ok: false,
      error
    }));

/**
 * Strip HTML tags from a html string.
 *
 * @param html
 * @returns
 */
export function stripHtmlTags(html: string = ''): string {
  const htmlRegX = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g;
  return html.replace(htmlRegX, '');
};

// export function Poller() {
//   let pollHandle: any | undefined;
//   const settings = inject(SettingsService);
//   const pollingPeriod = settings.getSettings().pollingPeriod;
//   console.log('Poller:pollingPeriod: ', pollingPeriod);

//   function startPolling(pollFn: () => void): void {
//     if (!isNotNull(pollHandle))
//       pollHandle = setInterval(pollFn, pollingPeriod || 60000);
//   }
//   function stopPolling(): void {
//     clearInterval(pollHandle);
//     pollHandle = undefined;
//   }

//   return {
//     startPolling,
//     stopPolling
//   };

// }


export type fieldNames = string | string[];

export function setFocus(formName: ElementRef, name: fieldNames) {
  console.log('setFocus: type: ', typeof name);
  console.log('setFocus; name: ', name);
  if (typeof name === 'string') {
    const ele = formName.nativeElement[name]; // this.aForm.nativeElement[name];
    if (ele) {
      ele.focus();
    }
  } else {
    console.log('setFocus: isArray?', Array.isArray(name));
    if (Array.isArray(name)) {
      name.forEach(n => {
        console.log('setFocus: n', n);
        // let el = this.aForm.nativeElement[n];
        let el = formName.nativeElement[n];
        if (el) {
          el.focus();
        }
      })
    }
  }
};


/**
 * Take a number and pad it with zero for the
 * size given.  If not size, will default to 2
 *
 * @param {number} num
 * @param {number} size
 * @returns {string} Zero padded number as string
 */
export function zeroPadNumber(num: number | string, size: number = 2): string {
  let s: string;
  if (typeof num === 'string') {
    s = num;
  } else {
    s = num.toString();
  }
  while (s.length < size) s = "0" + s;
  return s;
}


export function _goTo(location: string) {
  window.location.hash = '';
  //window.location.hash = location;
  let foo = location.split('#');
  let baz = foo[foo.length - 1];
  setTimeout(() => {
    // $('html,body').animate({
    //   scrollTop: $("#" + baz).offset().top
    // }, 'slow');
  });

}

export function formatText(text?: string): string {
  if (!text) {
    return '';
  }
  if (text.match(/\<(.)\>/)) //if html do nothing
    return text;
  else {
    let tmp = text.split('\n');
    let result = '';
    tmp.forEach((line) => {
      let newStr = line.replace(/\*\*(.*?)\*\*/g, (match: string) => {
        let r = `<b>${match.replace(/\*\*/, '').replace(/\*\*/, '')}</b>`;
        return r;
      });
      result += `<p>${newStr}</p>`
    });
    return result;
  }
}

export function formatTextLink(text?: string, id?: string): string {
  if (!text) {
    return '';
  }
  if (text.match(/\<(.)\>/)) //if html do nothing
    return text;
  else {
    let tmp = text.split('\n');
    let result = '';
    tmp.forEach((line) => {
      let newStr = line.replace(/\*\*(.*?)\*\*/g, (match: string) => {
        let r = `<b>${match.replace(/\*\*/, '').replace(/\*\*/, '')}</b>`;
        return r;
      });
      result += `<p>${newStr}</p>`
    });
    if (result != '')
      return `<a href="/userstory/show/${id}" target="_blank">${result}</a>`;
    else
      return result;
  }
}

export function sortStatus(a: CasiStoryStatus, b: CasiStoryStatus): number {
  let aLower = a.user_story_status_description.toLowerCase();
  let bLower = b.user_story_status_description.toLowerCase();
  // this.logger.debug(`sortStatus: `, {
  //   aLower, bLower
  // });
  if (aLower < bLower)
    return -1;
  if (aLower > bLower)
    return 1;
  return 0;
}

// export const ruleEngine = new RuleEval();
